import { api } from "@/shared/libs/axiosClient";
import { DeleteUserResponse, ListUsersResponse, UpsertUserRequest, UserResponse } from "@/types";

export function listControlPanelUsers(): Promise<ListUsersResponse> {
  return api.get<ListUsersResponse>("/user/list");
}

export function getControlPanelUser(userId: number): Promise<UserResponse> {
  return api.get<UserResponse>(`/user/${userId}`);
}

export function createControlPanelUser(req: UpsertUserRequest): Promise<UserResponse> {
  return api.post<UserResponse>("/user", req);
}

export function updateControlPanelUser(userId: number, req: Partial<UpsertUserRequest>): Promise<UserResponse> {
  return api.patch<UserResponse>(`/user/${userId}`, req);
}

export function deleteControlPanelUser(userId: number): Promise<DeleteUserResponse> {
  return api.delete<DeleteUserResponse>(`/user/${userId}`);
}